if (!customElements.get('custom-trustpilot-desktop-expand')) {
  customElements.define(
    'custom-trustpilot-desktop-expand',
    class CustomTrustpilotDesktopExpand extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.custom-trustpilot-widget__desktop-viewport');
        this.widget = this.querySelector('.custom-trustpilot-widget__trustbox--desktop .trustpilot-widget');
        this.footer = this.querySelector('.custom-trustpilot-widget__desktop-footer');
        this.button = this.querySelector('.custom-trustpilot-widget__show-more');
        this.collapsedHeight = Number(this.dataset.collapsedHeight);
        this.expandedHeight = Number(this.dataset.expandedHeight);

        if (!this.viewport || !this.widget || !this.button || !this.collapsedHeight || !this.expandedHeight) {
          return;
        }

        if (this.collapsedHeight >= this.expandedHeight) {
          this.expandedHeight = this.collapsedHeight + 290;
        }

        this.onToggle = this.onToggle.bind(this);
        this.onTransitionEnd = this.onTransitionEnd.bind(this);
        this.onSectionLoad = this.onSectionLoad.bind(this);

        this.widget.setAttribute('data-style-height', `${this.expandedHeight}px`);
        this.syncIframeHeight(this.expandedHeight, false);
        this.applyViewportHeight(false);

        this.viewport.addEventListener('transitionend', this.onTransitionEnd);
        this.button.addEventListener('click', this.onToggle);
        document.addEventListener('shopify:section:load', this.onSectionLoad);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:section:load', this.onSectionLoad);
        this.viewport?.removeEventListener('transitionend', this.onTransitionEnd);
        this.button?.removeEventListener('click', this.onToggle);
      }

      onSectionLoad(event) {
        if (event.target?.contains(this)) {
          this.applyViewportHeight(this.classList.contains('is-expanded'));
        }
      }

      onTransitionEnd(event) {
        if (event.propertyName !== 'height' || event.target !== this.viewport) {
          return;
        }

        this.classList.remove('is-animating');

        if (this.classList.contains('is-expanded') && this.footer) {
          this.footer.hidden = true;
        }
      }

      applyViewportHeight(isExpanded) {
        const height = isExpanded ? this.expandedHeight : this.collapsedHeight;

        this.viewport.style.height = `${height}px`;
        this.viewport.style.maxHeight = `${height}px`;
      }

      syncIframeHeight(height, animate) {
        const iframe = this.widget.querySelector('iframe');

        if (!iframe) {
          return;
        }

        iframe.style.transition = animate ? 'height 0.35s linear' : 'none';
        iframe.style.height = `${height}px`;
      }

      onToggle() {
        if (this.classList.contains('is-animating') || this.classList.contains('is-expanded')) {
          return;
        }

        this.classList.add('is-animating', 'is-expanded');
        this.button.disabled = true;
        this.button.setAttribute('aria-expanded', 'true');
        this.applyViewportHeight(true);
        this.syncIframeHeight(this.expandedHeight, true);

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.classList.remove('is-animating');
          if (this.footer) {
            this.footer.hidden = true;
          }
        }
      }
    },
  );
}
